import { APIComponentType, ArdoqId } from '@ardoq/api-types';

export const getAllTypeIds = (
  obj: Record<ArdoqId, APIComponentType>,
  typeIds: Set<string> = new Set()
) => {
  for (const id of Object.keys(obj)) {
    typeIds.add(id);
    if (obj[id].children) {
      getAllTypeIds(obj[id].children, typeIds);
    }
  }
  return typeIds;
};
